const ChatPage = () => {
  return null
}

export default ChatPage
